import React from 'react';

export default function VisualAnalytics() {
  return (
    <section style={s.section}>

      {/* Header */}
      <div style={s.header}>
        <h2 style={s.title}>
          Visual <span style={s.gradient}>Analytics</span>
        </h2>
        <p style={s.sub}>
          AI generates beautiful, insightful visualizations from your data automatically.
        </p>
      </div>

      {/* Cards */}
      <div style={s.grid}>

        {/* Card 1 - Bar Chart */}
        <div style={s.card}>
          <div style={s.cardTitle}>Monthly Revenue</div>
          <div style={s.cardSub}>Jan – Jun 2025</div>

          <div style={s.barChart}>
            {[40, 60, 50, 65, 75, 70].map((h, i) => (
              <div key={i} style={{ ...s.bar, height: `${h}%` }} />
            ))}
          </div>
        </div>

        {/* Card 2 - Donut */}
        <div style={s.card}>
          <div style={s.cardTitle}>Traffic Sources</div>
          <div style={s.cardSub}>Distribution breakdown</div>

          <div style={s.donutWrap}>
            <div style={s.donut} />
          </div>

          <div style={s.legend}>
            <span>● Direct</span>
            <span>● Organic</span>
            <span>● Referral</span>
            <span>● Social</span>
          </div>
        </div>

        {/* Card 3 - Line Chart */}
        <div style={s.card}>
          <div style={s.cardTitle}>Growth Trend</div>
          <div style={s.cardSub}>Users & Sessions</div>

          <div style={s.lineChart}>
            <div style={s.line1}></div>
            <div style={s.line2}></div>
          </div>
        </div>

      </div>

    </section>
  );
}
const s = {
  section: {
    padding: '90px 80px',
    textAlign: 'center',
    background:'linear-gradient(135deg,#eef2ff,#f8fafc)'
  },

  header: {
    marginBottom: 60,
  },

  title: {
    fontSize: 36,
    fontWeight: 800,
    marginBottom: 10,
  },

  gradient: {
    background: 'linear-gradient(135deg,#6366f1,#8b5cf6)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
  },

  sub: {
    fontSize: 15,
    color: 'var(--text-muted)',
  },

  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: 24,
  },

  card: {
    textAlign: 'left',
    padding: '26px',
    borderRadius: 18,
    background: '#fff',
    border: '1px solid rgba(0,0,0,0.05)',
    boxShadow: '0 12px 40px rgba(0,0,0,0.05)',
  },

  cardTitle: {
    fontWeight: 700,
    marginBottom: 4,
  },

  cardSub: {
    fontSize: 13,
    color: 'var(--text-muted)',
    marginBottom: 20,
  },

  /* BAR CHART */
  barChart: {
    display: 'flex',
    alignItems: 'flex-end',
    gap: 10,
    height: 120,
  },

  bar: {
    width: 18,
    borderRadius: 6,
    background: 'linear-gradient(180deg,#6366f1,#8b5cf6)',
  },

  /* DONUT */
  donutWrap: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 16,
  },

  donut: {
    width: 120,
    height: 120,
    borderRadius: '50%',
    background: 'conic-gradient(#6366f1 0% 35%, #8b5cf6 35% 60%, #22c55e 60% 75%, #38bdf8 75% 100%)',
    position: 'relative',
  },

  legend: {
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 12,
    color: 'var(--text-muted)',
  },

  /* LINE CHART */
  lineChart: {
    height: 120,
    position: 'relative',
  },

  line1: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(to top right, rgba(99,102,241,0.2), transparent)',
    borderTop: '2px solid #6366f1',
  },

  line2: {
    position: 'absolute',
    width: '100%',
    height: '100%',
    background: 'linear-gradient(to top right, rgba(139,92,246,0.2), transparent)',
    borderTop: '2px solid #8b5cf6',
  },
};